import { ButtonTypes } from '@paywithextend/components'
import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import React from 'react'
import SvgFilterFunnel from 'src/components/Svgs/SvgFilterFunnel'
import { useTranslate } from 'src/localization/Trns'

import styles from './UtilityToolbarFilterButton.style'

interface UtilityToolbarFilterButtonProps {
  onFilterButtonClick: () => void
  selectedFiltersCount: number
  /**
   * Renders the button's name beside its icon. On for the redesigned
   * card-detail Transactions tab (EX-40736), whose design labels both toolbar
   * actions; off everywhere else, so every other report keeps the icon-only
   * button and its width.
   */
  withLabel?: boolean
}

const UtilityToolbarFilterButton: React.FC<UtilityToolbarFilterButtonProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      className={cn('UtilityToolbarFilterButton', 'container', {
        selected: props.selectedFiltersCount > 0,
      })}
      css={styles}
    >
      <Button
        data-testid={'filtersButton'}
        type={ButtonTypes.button}
        variant={'toolbar'}
        dropShadow={false}
        onClick={(): void => {
          props.onFilterButtonClick()
        }}
        aria-label={translate('Toggle filters')}
      >
        <span className={'UtilityToolbarFilterButton icon'}>
          <SvgFilterFunnel />
        </span>
        {/* After the icon, per the design. The `aria-label` above already named
            the control, so this is the visible half of a name it always had. */}
        {props.withLabel === true && <span>{translate('Filter')}</span>}
      </Button>
      <div
        className={cn('countBadge', {
          visible: props.selectedFiltersCount > 0,
        })}
      >
        {props.selectedFiltersCount}
      </div>
    </div>
  )
}

export default UtilityToolbarFilterButton
